<template>
    <div class="module_list">
        <div class="left">
            <div class="header">
                模板生成
            </div>
            <el-scrollbar>
                <div class="main">
                    <div class="module-item" style="" v-for="(item, index) in module_listArr" :key="index">
                        <span style="color: #ffffff; width: 10px;margin-left:10px;display: block;">{{ index + 1 }}</span>
                        <div class="no_content" v-if="JSON.stringify(item) == '{}'">
                            <i class="el-icon-plus"></i>
                        </div>
                        <div class="content" v-else style="cursor: pointer;">

                            <!-- <img src="../../assets/img/image/newanli.png" alt=""> -->
                            <img :src="getImageUrl(item)" alt="">
                            <p> {{ item.title }}</p>

                        </div>
                        <span v-if="JSON.stringify(item) !== '{}'" style="cursor: pointer;" class="circle"  @click="deleteTemp(item, index)"><i class="el-icon-minus"
                                        style="color: #ffffff;"></i></span>
                    </div>
                    <div class="copy_main">
                        <draggable :list="CourseCustom" :group="{ name: 'resources', }" style="">
                            <div class="module-item" style="" v-for="(item, index) in CourseCustom" :key="index">
                                <!-- <span style="color: #ffffff; width: 10px;margin-left:10px;display: block;">{{ index+1 }}</span> -->
                                <div class="no_content" v-if="JSON.stringify(item) == '{}'">
                                    <!-- <i class="el-icon-plus"></i> -->
                                </div>
                                <div class="content" v-else style="cursor: pointer;">

                                </div>
                                <span v-if="JSON.stringify(item) !== '{}'"   style="background-color: transparent; cursor: pointer;" class="circle"
                                    @click="deleteTemp(item, index)"></span>
                            </div>

                        </draggable>
                    </div>
                </div>
            </el-scrollbar>

            <div class="footer">
                <div class="footer-box">
                    <el-popover placement="top-start" width="280" trigger="click" popper-class="modul-yt-popver"
                        style="background: #333333;">
                        <el-scrollbar>
                            <div class="modulList">
                                <div class="popover-item" :class="{'active-popover-item':activePopoverIndex==index}" v-for="(item,index) in courseTempList">
                                    <div class="moudle_name" style="cursor: pointer;" @click="selectTempClick(item,index)">{{ item.name }}</div>
                                    <i class="iconfont" style="cursor: pointer;" @click.stop="deleTemp(item.id)">&#xe60a;</i>
                                </div>


                                <div v-if="courseTempList.length === 0"
                                    style="text-align: center; width:100%; padding-top: 100px;box-sizing: border-box;">暂无模板
                                </div>
                            </div>
                        </el-scrollbar>
                        <div class="footer_btn" slot="reference" style="color: #006EFF;cursor: pointer;">选择</div>
                    </el-popover>

                    <div class=" footer_btn footer_btn1" @click="saveTempListDialog()">保存</div>
                    <div class=" footer_btn footer_btn1" @click="saveCourseTemp()">应用</div>
                </div>
            </div>
            <el-dialog title="保存模板" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
                <div class="modul_name">
                    <!-- <span></span>
                <span>模板名称</span>
                <el-input v-model="moduleName" placeholder="输入名称3-10字"></el-input> -->
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                        <el-form-item label="模板名称" prop="moduleName">
                            <el-input v-model="ruleForm.moduleName" placeholder="输入名称3-10字"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleClose">取 消</el-button>
                    <el-button type="primary" @click="saveTempList">确 定</el-button>
                </span>
            </el-dialog>

        </div>
        <div class="right">
            <div class="resourse">
                <div class="resource_header">
                    <span class="name">一级资源:</span>
                    <span class="resourse_item" v-for="(item, index) in featuredCourseList"
                        :class="{ activeIitem: activeFirstIndex == index }" @click="getResourceList(item.index, index)">{{
                            item.title
                        }}</span>
                </div>
                <div class="resource_header" style="margin-top: 20px;" v-if="activeFirstIndex == 8">
                    <span class="name">二级资源:</span>
                    <span class="resourse_item" :class="{ activeIitem: second_idnex == index }" @click="changeType(item.id)"
                        v-for="(item, index) in newTypeList">{{ item.name }}</span>
                </div>
            </div>
            <div class="resourse_list">
                <div class="list_box" style="width: 100%;height: 100%;">
                    <el-scrollbar style="height: 100%;width: 100%;">
                        <draggable v-if="activeFirstIndex !== 8" :list="showResourseList"
                            :group="{ name: 'resources', pull: 'clone', put: false }" :sort="false" :multiple="false"
                            :move="onMove1" @end="onEnd" class="dragg-box">

                            <div v-for="item in showResourseList" class="item_box">
                                <!-- <img src="../../assets/img/image/newanli.png" alt=""> -->
                                <img :src="getImageUrl(item)" alt="">
                                <p>{{ item.title }}</p>
                            </div>
                            <div v-if="showResourseList.length == 0" class="nodata">
                                <img src="../../assets/teacherIcon/noDataye.png" alt="">
                                <p> 暂无数据</p>

                            </div>
                        </draggable>
                        <draggable v-else :list="showPeitao" :group="{ name: 'resources', pull: 'clone', put: false }"
                            :sort="false" :multiple="false" :move="onMove1" @end="onEnd" class="dragg-box">

                            <div v-for="item in showPeitao" class="item_box">
                                <!-- <img src="../../assets/img/image/newanli.png" alt=""> -->
                                <img :src="getImageUrl(item)" alt="">
                                <p> {{ item.resource_title }}</p>
                            </div>
                            <div v-if="showPeitao.length == 0" class="nodata">
                                <img src="../../assets/teacherIcon/noDataye.png" alt="">
                                <p> 暂无数据</p>
                            </div>

                        </draggable>


                    </el-scrollbar>
                </div>
            </div>

        </div>

    </div>
</template>
<script>
import tHttp from "../../utils/teacher_http";
import draggable from "vuedraggable";
import _ from "underscore";

export default {
    name: "preparelessonsModule",
    props: ['select_list', 'module_list', 'searchInput', 'courseInfos', 'showResourseList', 'showPeitao', "setTempModule"],
    components: {
        draggable
    },
    watch: {
        showResourseList: function (val) {
            console.log("资源",val);

        },
        showPeitao: function (val) {
            console.log("配套",val);

        },
        courseInfos: function (val) {

            this.getResourceList(0, 0)
            this.getCourseCustom()
            this.selectCourseTemp()
        }

    },
    data() {
        return {
            //精选课程
            featuredCourseList: [
                 {
                    class: 'courseware',
                    icon: '&#xe737;',
                    src: require('../../assets/images/courseware.png'),
                    title: '全部',
                    index: 0,
                    mtype: 0,
                    number: 0
                },
                {
                    class: 'courseware',
                    icon: '&#xe737;',
                    src: require('../../assets/images/courseware.png'),
                    title: '课件',
                    index: 1,
                    mtype: 0,
                    number: 0
                },
                {
                    class: 'textbook',
                    icon: '&#xe71b;',
                    src: require('../../assets/images/textbook.png'),
                    title: '教材',
                    index: 2,
                    mtype: 0,
                    number: 1
                },
                {
                    class: 'micro-lesson',
                    icon: '&#xe71d;',
                    src: require('../../assets/images/micro-lesson.png'),
                    title: '微课',
                    index: 3,
                    mtype: 0,
                    number: 2
                },
                {
                    class: 'animation',
                    icon: '&#xe72f;',
                    src: require('../../assets/images/animation.png'),
                    title: '教学设计',
                    index: 4,
                    mtype: 0,
                    number: 3
                },
                {
                    class: 'test-center',
                    icon: '&#xe738;',
                    src: require('../../assets/images/test-center.png'),
                    title: '测试中心',
                    index: 6,
                    mtype: 0,
                    number: 4
                },
                {
                    class: 'training-center',
                    icon: '&#xe71c;',
                    src: require('../../assets/images/training-center.png'),
                    title: '实训中心',
                    index: 7,
                    mtype: 0,
                    number: 5
                },
                {
                    class: 'supporting-material',
                    icon: '&#xe72e;',
                    title: '个人资源',
                    index: 8,
                    mtype: 0,
                    number: 6
                },
              
                {
                    class: 'supporting-material',
                    icon: '&#xe72e;',
                    title: '配套材料',
                    index: 9,
                    mtype: 0,
                    number: 6
                },
              

            ],
            newTypeList: [
                { id: 0, name: "全部" },
                {
                    id: 1,
                    name: '知识点',
                }, {
                    id: 2,
                    name: "素材库",
                }, {
                    id: 3,
                    name: '案例库'
                }, {
                    id: 4,
                    name: '视频'
                }, {
                    id: 5,
                    name: '相关文章'
                }],
            first_index: 0,
            second_idnex: 0,
            course_id: "",
            chapteIndex: "",
            nodeIndex: "",
            CourseCustom: [],//模板列表
            courseID: "",//章节模板id
            courseTemp: [],//选择模板列表
            activeFirstIndex: 0,
            tempList: [
                {
                    name: '课件',
                    color: "#608EFF",
                    icon_url: require('../../assets/img/image/kejian.png'),
                    id: 1,
                    material_type_id: -1,
                    resource_type_id: 1

                }, {
                    name: '教材',
                    color: "#608EFF",
                    icon_url: require('../../assets/img/image/know.png'),
                    id: 2,
                    material_type_id: -1,
                    resource_type_id: 2

                }, {
                    name: '微课',
                    color: "#3B85E0",
                    icon_url: require('../../assets/img/image/weike.png'),
                    id: 3,
                    material_type_id: -1,
                    resource_type_id: 3

                }, {
                    name: '知识点',
                    color: "#608EFF",
                    icon_url: require('../../assets/img/image/know.png'),
                    id: 5,
                    material_type_id: 1,
                    resource_type_id: 5,

                }, {
                    name: '教学设计',
                    color: "#EDA11E",
                    icon_url: require('../../assets/img/image/jiaoxuesheji.png'),
                    id: 6,
                    material_type_id: -1,
                    resource_type_id: 6

                }, {
                    name: '素材库',
                    color: "#3B85E0",
                    icon_url: require('../../assets/img/image/newsucai.png'),
                    id: 5,
                    material_type_id: 2,
                    resource_type_id: 5

                }, {
                    name: '案例库',
                    color: "#EDA11E",
                    icon_url: require('../../assets/img/image/newanli.png'),
                    id: 5,
                    material_type_id: 3,
                    resource_type_id: 5

                }, {
                    name: '视频',
                    color: "#7451D5",
                    icon_url: require('../../assets/img/image/newvideo.png'),
                    id: 5,
                    material_type_id: 4,
                    resource_type_id: 5

                }, {
                    name: '相关文章',
                    color: "#4277E2",
                    icon_url: require('../../assets/img/image/article.png'),
                    id: 5,
                    material_type_id: 5,
                    resource_type_id: 5

                }, {
                    name: '测试中心',
                    color: "#608EFF",
                    icon_url: require('../../assets/img/image/ceshi.png'),
                    id: 0,
                    material_type_id: 0,
                    ctype: 4

                },
                {
                    name: '实训中心',
                    color: "#608EFF",
                    icon_url: require('../../assets/img/image/shixun.png'),
                    id: 0,
                    material_type_id: 0,
                    ctype: 5
                },
                {
                    name: '个人资源',
                    color: "#608EFF",
                    icon_url: require('../../assets/img/image/newsucai.png'),
                    id: 5,
                    material_type_id: 8,
                    ctype:6

                }

            ],
            module_listArr: [],
            id: "",
            modulName: "",
            dialogVisible: false,
            courseTempList: [],
            ruleForm: {
                moduleName: ""
            },
            rules: {
                moduleName: [
                    { required: true, message: '请输入模板名称', trigger: 'blur' },
                    { min: 3, max: 10, message: '长度在 3 到 10 个字符', trigger: 'blur' }
                ]
            },
            activePopoverIndex:-1

        }
    },

    mounted() {

        this.getResourceList(0, 0)
        this.course_id = this.$route.query.course_id
        this.chapteIndex = this.$route.query.zhangIndex
        this.nodeIndex = this.$route.query.jieIndex

        this.getCourseCustom()
        this.selectCourseTemp()
    },

    methods: {
        getResourceList(val, num) {
            this.activeFirstIndex = num
            localStorage.setItem('activeFirstIndex', this.activeFirstIndex)
            if (val != 9) {
                this.$emit('handleShowResourse', val)
            } else {
                console.log(val,'配套材料');
                this.changeType(0)
            }


        },
        changeType(val) {
            this.second_idnex = val

            this.$emit('handlegetPeitao', val)
        },

        onMove1(evt) {
            let obj = evt.draggedContext.element//拖拽对象
            let objn = evt.relatedContext.element//目标对象
            // console.log("拖拽对象",obj);
            // console.log("目标对象",objn);
            let index = this.CourseCustom.findIndex(item => item.id == obj.id)
            if (index != -1) return false

            // console.log(evt.draggedContext.element,"移动中");

        },
        onEnd(evt) {
            // console.log("添加之前",this.CourseCustom);
            // console.log(evt,"pppppppp");
            let newIndex = evt.newIndex;
            if (this.CourseCustom.length > 14) {
                if (this.CourseCustom[newIndex + 1].id) {
                    this.CourseCustom.splice(newIndex, 1)
                } else {
                    this.CourseCustom.splice(newIndex + 1, 1)
                }
            }
            // console.log("添加之后",this.CourseCustom);
            this.module_listArr = this.CourseCustom
        },

        getCourseCustom() {
            let param = {
                course_id: this.course_id,
                course_chapter: this.chapteIndex,
                course_node: this.nodeIndex
            }
            let arr = new Array(14).fill({});
            this.CourseCustom = arr
            this.module_listArr = this.CourseCustom
            this.$thttp.axiosGetBy(this.$api.course_getcoursecustom, param, (res) => {
                //    console.log(res,"hhhhhhhhh");
                if (Array.isArray(res.data)){
                    this.showResourseList.forEach((item,index)=>{
                            if(index<14){
                                this.CourseCustom.splice(index,1,item)
                            }
                        })
                        this.module_listArr=this.CourseCustom
               
                        return false
                }else{
                    if (res.data.course_content.length > 0) {
                    res.data.course_content.forEach(item => {
                        let obj = {}
                        if (res.data.resources) {
                            obj = res.data.resources.find(data => item.id == data.resource_id)
                        }
                        if (!obj) {
                            obj = res.data.exams ? res.data.exams.find(data => item.id == data.id) : {}
                        }
                        if (!obj) obj = res.data.projects ? res.data.projects.find(data => item.id == data.id) : {}
                        if (!obj) obj = res.data.materials ? res.data.materials.find(data => item.id == data.id) : {}

                        let newObj = {
                            ctype: item.type,
                            id: item.id,
                            index: item.index,
                            title: obj.resource_title || obj.paper_name || obj.project_title || obj.title,// 1 课件  2教材  3微课  5配套材料   6教案
                            material_type_id: obj.material_type_id, // 1知识点  2素材库  3案例库  4MG动画   5相关文章  6应用中心  7链接  8个人资源
                            resource_type_id: obj.resource_type_id
                        }

                        // this.CourseCustom[item.index]=newObj
                        this.CourseCustom.splice(item.index, 1, newObj)
                        // this.CourseCustom.forEach(item=>{
                        //     if(!item.id){
                        //         item={}
                        //     }
                        // })
                        // console.log(this.CourseCustom,"保存之后重新赋值");

                        this.module_listArr = this.CourseCustom

                    })
                    this.id = res.data.id
                }else{
                
                        this.showResourseList.forEach((item,index)=>{
                            if(index<14){
                                this.CourseCustom.splice(index,1,item)
                            }
                        })
                        this.module_listArr=this.CourseCustom

                    

                }

                }
                


            })
        },
        deleteTemp(item, index) {
            this.CourseCustom.splice(index, 1, {})

        },
        saveCourseTemp() {
            let arr = []
            console.log(this.CourseCustom,'保存模板');
            this.CourseCustom.forEach((item, index) => {
                if (item.id) {
                    let obj = {
                        type: item.ctype,
                        id: item.id,
                        index: index
                    }
                    arr.push(obj)
                }
            })
            if (arr.length == 0) {
                this.$message.warning('请选择至少一个模板！')
                return false
            }
            // console.log(this.CourseCustom,"保存的时候");
            console.log(arr,"保存传递的参数");

            let param = {
                course_id: this.course_id,
                course_chapter: this.chapteIndex,
                course_node: this.nodeIndex,
                id: this.id,
                course_content: JSON.stringify(arr)
            }
            this.$thttp.axiosPost(this.$api.saveCourseCustom, param, (res) => {
                if (res.code == 200) {
                    this.$message.success('应用成功')
                    this.getCourseCustom()
                }
            })
        },
        selectCourseTemp() {
            // 获取模板列表
            let param = {
                course_id: this.course_id,
                course_chapter: this.chapteIndex,
                course_node: this.nodeIndex,
            }
            this.$thttp.axiosGetBy(this.$api.course_getCourseTemp, param, res => {
                if (res.code === 200) {
                    this.courseTempList = res.data;
                } else {
                    this.$message.warning(res.msg)
                }
            })

        },
        saveTempList() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    if (this.CourseCustom.length == 0) {
                        this.$message.warning('请选择至少一个模板！')
                        return false
                    }
                    let arr = []
                    this.CourseCustom.forEach((item, index) => {
                        if (item.id) {
                            let obj = {
                                type: item.ctype,
                                id: item.id,
                                index: index
                            }
                            arr.push(obj)
                        }
                    })
                    let param = {
                        course_id: this.course_id,
                        course_chapter: this.chapteIndex,
                        course_node: this.nodeIndex,
                        name: this.ruleForm.moduleName,
                        course_content: JSON.stringify(arr)
                    }
                    this.$thttp.axiosPost(this.$api.course_saveCourseTemp, param, res => {

                        if (res.code === 200) {
                            this.$message.success("保存成功")
                            this.dialogVisible = false
                            // 获取模板列表
                            this.selectCourseTemp()
                        } else {
                            this.$message.warning(res.msg)
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });



        },
        handleClose() {
            this.dialogVisible = false
            this.ruleForm.moduleName = ""


        },
        saveTempListDialog() {
            this.dialogVisible = true
            this.ruleForm.moduleName = ""

        },
        deleTemp(id) {
            this.$confirm('此操作将永久删除该模板, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$thttp.axiosGetBy(this.$api.course_delCourseTemp, { id: id }, res => {
                    // console.log(res)
                    if (res.code === 200) {
                        this.$message({
                            message: '删除成功！',
                            type: 'success',
                            duration: 1000,
                            onClose: () => {
                                // this.$emit('updateTempList')
                                this.selectCourseTemp()
                            }
                        })
                    } else {
                        this.$message.warning(res.msg)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            })

        },
        selectTempClick(val,index) {
            this.activePopoverIndex=index
            

            // this.$emit("selectTempClick",item)
            let arr = new Array(14).fill({});
            this.CourseCustom = arr
            let courseData = JSON.parse(val.course_content)
            courseData.forEach(item => {
                // let obj=val.resources.find(data=>item.id==data.resource_id)
                let obj = {}
                if (val.resources) {
                    obj = val.resources.find(data => item.id == data.resource_id)

                }
                if (!obj) {
                    obj = val.exams ? val.exams.find(data => item.id == data.id) : {}
                }
                if (!obj) obj = val.projects ? val.projects.find(data => item.id == data.id) : {}
                if (!obj) obj = val.materials ? val.materials.find(data => item.id == data.id) : {}
                let newObj = {
                    ctype: item.type,
                    id: item.id,
                    index: item.index,
                    title: obj.resource_title || obj.paper_name || obj.project_title || obj.title,// 1 课件  2教材  3微课  5配套材料   6教案
                    material_type_id: obj.material_type_id, // 1知识点  2素材库  3案例库  4MG动画   5相关文章  6应用中心  7链接  8个人资源
                    resource_type_id: obj.resource_type_id
                }
                this.CourseCustom[item.index] = newObj

            })
            this.CourseCustom.forEach(item => {
                if (!item.id) {
                    item = {}
                }
            })
            this.id = val.id
            this.module_listArr = this.CourseCustom

        },
        getImageUrl(item) {
            let imgUrl = ""
            this.tempList.forEach(data => {
                // if(item.resource_type_id!=5){
                //         if(data.resource_type_id==item.resource_type_id){
                //             imgUrl=data.icon_url
                //         }
                // }else{
                //     // 配套材料的
                //     if(data.material_type_id==item.material_type_id){
                //         imgUrl=data.icon_url
                //     }
                // }
                if (item.resource_type_id) {
                    if (item.resource_type_id != 5) {
                        if (data.resource_type_id == item.resource_type_id) {
                            imgUrl = data.icon_url
                        }
                    } else {
                        // 配套材料的
                        if (data.material_type_id == item.material_type_id) {
                            imgUrl = data.icon_url
                        }
                    }
                } else {
                    if (item.ctype == data.ctype) {
                        imgUrl = data.icon_url

                    }
                }
            })
            return imgUrl

        }
    }
}
</script>
<style lang="scss" scoped> 
.module_list {
     display: flex;
     width: 100%;
     height: 100%;

     .left {
         width: 400px;
         background: #2D2D2D;
         height: 100%;

         .header {
             width: 100%;
             height: 60px;
             border-bottom: 1px solid #FFFFFF;
             display: flex;
             align-items: center;
             justify-content: center;
             font-family: PingFang SC, PingFang SC;
             font-weight: 400;
             font-size: 16px;
             color: #FFFFFF;
             line-height: 19px;
             text-align: left;
             font-style: normal;
             text-transform: none;


         }
         ::v-deep .el-scrollbar {
                     .el-scrollbar__wrap {
                         overflow-x: hidden;

                         .el-scrollbar__view {
                            // overflow-x: hidden;
                           
                         }
                     }

                 }

         .main {
             width: 400px;
             height: calc(100vh - 277px);
             //  background-color: pink;
             //  display: flex;
             //  flex-wrap: wrap;
             padding-top: 30px;
             box-sizing: border-box;
             position: relative;

             .module-item {
                 width: 400px;
                 height: 50px;
                 margin-bottom: 30px;
                 display: flex;
                 justify-content: flex-start;
                 align-items: center;
                 position: relative;



                 .no_content {
                     background: #2D2D2D;
                     border-radius: 4px 4px 4px 4px;
                     border: 1px solid #999999;
                     display: flex;
                     align-items: center;
                     justify-content: center;
                     color: #999999;
                     width: 300px;
                     height: 50px;
                     margin-left: 20px;
                     box-sizing: border-box;

                 }

                 .content {
                     width: 300px;
                     background: #424242;
                     border-radius: 4px 4px 4px 4px;
                     display: flex;
                     align-items: center;
                     padding: 10px;
                     color: #FFFFFF;
                     margin-left: 20px;
                     height: 50px;
                     box-sizing: border-box;

                     img {
                         width: 30px;
                         height: 30px;
                     }

                     p {
                         width: 260px;
                         white-space: nowrap;

                         overflow: hidden;

                         text-overflow: ellipsis;

                     }
                 }

                 .circle {
                     display: block;
                     width: 20px;
                     height: 20px;
                     padding: 5px;
                     box-sizing: border-box;
                     border-radius: 20px;
                     background-color: red;
                     display: flex;
                     align-items: center;
                     justify-content: center;
                     margin-left: 14px;
                 }

             }
         }

         .copy_main {
             position: absolute;
             background-color: transparent;
             top: 0;
             left: 0;
             padding-top: 30px;
             width: 340px;
             //  height: calc(100vh - 277px);
             padding-left: 20px;
             box-sizing: border-box;
             

             .module-item {
                width: 360px;
                // background-color: pink;
                 background-color: transparent;
                 .content{
                    width: 303px;
                    background-color: transparent;
                    border: none;
                 }
                 .no_content{
                    width: 300px;
                    background-color: transparent;
                    border: none;
                 }
             }


         }

         .footer {
             width: 340px;
             height: 80px;
             background: #383838;
             position: fixed;
             bottom: 0;
             left: 0;

             .footer-box {
                 width: 100%;
                 height: 100%;
                 display: flex;
                 align-items: center;
                 justify-content: space-evenly;

                 .footer_btn {
                     width: 72px;
                     height: 30px;
                     background: #383838;
                     border-radius: 4px 4px 4px 4px;
                     border: 1px solid #006EFF;
                     display: flex;
                     align-items: center;
                     justify-content: center;
                     color: #006EFF;
                     cursor: pointer;
                 }

                 .footer_btn1 {
                     background: #006EFF;
                     color: #FFFFFF;
                 }
             }
         }

     }

     .right {
         flex: 1;
         width: 0;
         padding: 20px;
         box-sizing: border-box;

         .resourse {
             width: 100%;
            //  height: 100px;
             background-color: #FFFFFF;
             padding: 20px;
             box-sizing: border-box;

             .resource_header {
                 font-family: PingFang SC, PingFang SC;
                 font-weight: 400;
                 font-size: 18px;
                 color: #666666;
                 line-height: 21px;
                 text-align: left;
                 font-style: normal;
                 text-transform: none;

                 .name {
                     margin-right: 40px;
                 }

                 .resourse_item {
                     padding: 0 20px;
                     cursor: pointer;
                 }

                 .activeIitem {
                     color: #006EFF;
                 }

             }
         }

         .resourse_list {
             margin-top: 20px;
             width: 100%;
             height: calc(100vh - 234px);
             background-color: #FFFFFF;
             padding: 32px;
             box-sizing: border-box;
             display: flex;

             .list_box {
                 width: 100%;
                 display: flex;
                 flex-wrap: wrap;

                 ::v-deep .el-scrollbar {
                     .el-scrollbar__wrap {
                         overflow-x: hidden;

                         .el-scrollbar__view {
                             .dragg-box {
                                 display: flex;
                                 flex-wrap: wrap;

                             }
                         }
                     }

                 }

                 .item_box {
                     width: 300px;
                     height: 80px;
                     background: #F2F6FA;
                     border-radius: 4px 4px 4px 4px;
                     border: 1px solid #E1E6F0;
                     display: flex;
                     align-items: center;
                     padding: 10px;
                     box-sizing: border-box;
                     margin-left: 20px;
                     margin-bottom: 20px;

                     img {
                         width: 60px;
                         height: 60px;
                     }

                     p {
                         width: 220px;
                         white-space: nowrap;
                         overflow: hidden;
                         text-overflow: ellipsis;
                     }
                 }

                 .nodata {
                     width: 100%;
                     height: 100%;
                     display: flex;
                     justify-content: center;
                     align-items: center;
                     flex-direction: column;
                     padding-bottom: 200px;

                     img {
                         width: 370px;
                         height: 270px;
                         margin-top: 120px;
                     }
                 }

             }

         }
     }
 }

 .modul_name {
     display: flex;
 }

 .modulList {
     width: 100%;
     height: 240px;

     .popover-item {
         display: flex;
         width: 268px;
         height: 40px;
         align-items: center;
         justify-content: space-between;
         padding-left: 5px;
         box-sizing: border-box;
        //  background-color: #FFFFFF;
        //  margin-top: 5px;

         i {
             width: 20px;

         }

         .moudle_name {
             width: 240px;
             overflow: hidden;
             white-space: nowrap;
             text-overflow: ellipsis;
             display: block;
             font-family: PingFang SC, PingFang SC;
             font-weight: 400;
             font-size: 14px;
             color: #999999;
             font-style: normal;
             text-transform: none;
            //  background-color: #FFFFFF;

         }
     }
     .popover-item:hover{
        background-color: #1E1E1E;
        color: #ffffff !important;
        .moudle_name{
            color: #ffffff !important;
        }
        
     }
     .active-popover-item{
        background-color: #1E1E1E;
        color: #ffffff !important;
        .moudle_name{
            color: #ffffff !important;
        }

     }
 }

 ::v-deep .el-input__inner {
     width: 360px
 }

 ::v-deep .el-popover {
     background-color: #333333 !important;
 }
 ::v-deep .el-icon-close:before{
    line-height: 2!important;
}
</style>
<style>
.modul-yt-popver {
    background-color: #333333;
}</style>